module.exports = __webpack_public_path__ + "static/img/yinyue.4bcfd19.png";


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/yinyue.png
// module id = xfKk
// module chunks = 1